import script from "./BaseSelectInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSelectInput.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSelectInput.vue?vue&type=style&index=0&id=228b5df4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228b5df4"]])

export default __exports__